import { useContext } from "react";
import { LocaleUpdateContext } from "../customContext/localeProvider";

export function useUpdateLocaleCtx(){
    const ctx = useContext(LocaleUpdateContext);
    if(!ctx){
        throw new Error('useUpdateLocale must be used within LocaleProvider context')
    };
    return ctx
}